module.exports = __webpack_public_path__ + "static/media/vaken.1f3cd5bd.mp3";